import React from 'react';
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import useInterveneSendTemplate from '../hooks/useInterveneSendTemplate';
import InterveneSendTemplateForm from './InterveneSendTemplateForm';
import useInterveneSx from '../hooks/useInterveneSx';
import { Button } from '../../../components/ui';
import { useOptoutCheck } from '../../whatsapp-templates/services/optoutService';

export default function InterveneTemplateDialog({
  open,
  onClose,
  activeUser,
  botNumber,
  channelObj,
  organisationId,
  onTemplateSent,
}) {
  const styles = useInterveneSx().dialog;
  const { isOptedOut } = useOptoutCheck();
  const isUserOptedOut = isOptedOut(activeUser?.phone_number);
  const templateState = useInterveneSendTemplate({
    open,
    phoneNumber: activeUser?.phone_number,
    botNumber,
    channelObj,
    organisationId,
    onClose,
    onTemplateSent,
  });

  const canSubmit =
    templateState.isWhatsappTemplate &&
    templateState.phoneNumber &&
    !templateState.isSubmitting &&
    !isUserOptedOut;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { ...styles.paper, ...styles.templatePaper } }}
    >
      <DialogTitle sx={styles.title}>Send Template</DialogTitle>
      <DialogContent dividers sx={styles.content}>
        {isUserOptedOut ? (
          <Alert severity="error" sx={{ mb: 2, fontWeight: 500 }}>
            ⚠️ Contact has opted out of WhatsApp messages. Template cannot be sent to this user.
          </Alert>
        ) : null}
        <InterveneSendTemplateForm {...templateState} />
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button
          variant="secondary"
          size="sm"
          onClick={onClose}
          disabled={templateState.isSubmitting}
          sx={styles.cancelButton}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={templateState.submit}
          disabled={!canSubmit}
          loading={templateState.isSubmitting}
          sx={styles.submitButton}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
